import axios from "../../axiosDod.js";

const getDodAdmins = async ({ commit }) => {
  try {
    const dodAdminsList = await axios.get(`mainApp/admins`);
    commit("SET_DOD_ADMINS_LIST", dodAdminsList);
  } catch (error) {
    console.log(error);
  }
};

const fetchDodAdminNotifications = async ({ commit }) => {
  // Keep polling even while DOD access is revoked: a 403 keeps the module disabled
  // (silently, via the interceptor), and a 200 is the signal that access was
  // re-granted (the success interceptor re-enables DOD) - so recovery is automatic.
  try {
    const dodAdminNotifications = await axios.get(`notifications`);
    commit("SET_DOD_ADMIN_NOTIFICATIONS", dodAdminNotifications.data);
  } catch (error) {
    commit("SET_DOD_ADMIN_NOTIFICATIONS", []);
    console.log(error);
  }
};

const readDodAdminNotification = async ({ dispatch }, notificationId) => {
  await axios.put(`notifications/${notificationId}/read`);
  dispatch("fetchDodAdminNotifications");
};

export default {
  getDodAdmins,
  fetchDodAdminNotifications,
  readDodAdminNotification,
};
